import React from "react";
import '../_css/poster.css';
import { Link } from "react-router-dom";


function Poster(title, pic, path){
    return(
            <div className="posterBody">

                <Link to={path}>
                    <div className="picture">
                        <img src={pic} alt=""></img>
                    </div>
                </Link>

                <div className="title">
                    <p>{title}</p>
                </div>
                
            </div>
    );
}

export default Poster;
